export const RG_ERROR_CODES = {
	INVALID_PARAM: "InvalidParam",
	INVALID_LIMIT_TYPE: "InvalidLimitType",
	INVALID_PERIOD: "InvalidPeriod",
	EXCEEDS_BACKOFFICE_LIMIT: "ExceedsBackofficeLimit",
	PENDING_LIMIT_CHANGE: "PendingLimitChange",
	DEPOSIT_LIMIT_EXCEEDED: "DEPOSIT_LIMIT_EXCEEDED",
	SESSION_TIME_LIMIT_EXCEEDED: "SESSION_TIME_LIMIT_EXCEEDED",
	LOSS_LIMIT_EXCEEDED: "LOSS_LIMIT_EXCEEDED",
	BET_COUNT_LIMIT_EXCEEDED: "BET_COUNT_LIMIT_EXCEEDED",
};

export const parseRgError = (error) => {
	const data = error?.data || error?.response?.data || error?.error?.data || {};

	return {
		code: data.code,
		message: data.message || data.Message,
		remainingAllowance: data.remainingAllowance,
		type: data.type,
		period: data.period,
		currency: data.currency,
	};
};

export const isSessionTimeLimitError = (error) => {
	const { code } = parseRgError(error);

	return code === RG_ERROR_CODES.SESSION_TIME_LIMIT_EXCEEDED;
};

export const isDepositLimitError = (error) => {
	const { code } = parseRgError(error);

	return code === RG_ERROR_CODES.DEPOSIT_LIMIT_EXCEEDED;
};

export const isBetLimitError = (error) => {
	const { code } = parseRgError(error);

	return (
		code === RG_ERROR_CODES.LOSS_LIMIT_EXCEEDED ||
		code === RG_ERROR_CODES.BET_COUNT_LIMIT_EXCEEDED
	);
};

export const getDepositLimitAlertMessage = (error) => {
	const parsed = parseRgError(error);

	if (parsed.code === RG_ERROR_CODES.DEPOSIT_LIMIT_EXCEEDED) {
		return {
			msg: "limits.runtime.depositExceeded",
			msgParams: {
				remaining: parsed.remainingAllowance,
				currency: parsed.currency || "",
			},
		};
	}

	return {
		msg: parsed.message || "GENERIC_ERROR",
		noTranslate: Boolean(parsed.message),
	};
};

export const getBetLimitAlertMessage = (error) => {
	const parsed = parseRgError(error);

	if (parsed.code === RG_ERROR_CODES.LOSS_LIMIT_EXCEEDED) {
		return { msg: "limits.runtime.lossExceeded" };
	}

	if (parsed.code === RG_ERROR_CODES.BET_COUNT_LIMIT_EXCEEDED) {
		return { msg: "limits.runtime.betCountExceeded" };
	}

	return {
		msg: parsed.message || "GENERIC_ERROR",
		noTranslate: Boolean(parsed.message),
	};
};

export const getSessionTimeLimitAlertMessage = () => ({
	msg: "limits.runtime.sessionTimeExceeded",
	title: "limits.runtime.sessionTimeExceededTitle",
});

export const isProfileLimitTypeEnabled = (type) =>
	Array.isArray(window.PROFILE_LIMITS_MODULE) && window.PROFILE_LIMITS_MODULE.includes(type);

export const isProfileLimitsModuleEnabled = () =>
	Array.isArray(window.PROFILE_LIMITS_MODULE) && window.PROFILE_LIMITS_MODULE.length > 0;

export const shouldHandleDepositLimitError = (error) =>
	isDepositLimitError(error) && isProfileLimitTypeEnabled("deposit");

export const shouldHandleBetLimitError = (error) => {
	if (!isBetLimitError(error)) {
		return false;
	}

	const { code } = parseRgError(error);

	if (code === RG_ERROR_CODES.LOSS_LIMIT_EXCEEDED) {
		return isProfileLimitTypeEnabled("loss");
	}

	if (code === RG_ERROR_CODES.BET_COUNT_LIMIT_EXCEEDED) {
		return isProfileLimitTypeEnabled("betCount");
	}

	return false;
};

export const shouldHandleSessionTimeLimitError = (error) =>
	isSessionTimeLimitError(error) && isProfileLimitTypeEnabled("sessionTime");
